import {
  AvatarFallback as AvatarFallback,
  AvatarImage as AvatarImage,
  Root as AvatarRoot
} from "@radix-ui/react-avatar";
import { avatarFallback, avatarImage, avatarRoot } from "./Avatar.css";

function getInitials(name: string): string {
  const [firstName, lastName] = name.trim().split(/\s+/);
  const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : "";
  const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : "";
  return `${firstInitial}${lastInitial}`;
}

export interface AvatarProps {
  /** First and last name of the user */
  userName: string;
  /** The source URL of the avatar image */
  src?: string;
}

/**
 * Avatar component that displays a user's profile picture or initials.
 * If the image fails to load, it will display the user's initials.
 */
export function Avatar({ src, userName }: AvatarProps) {
  const initials = getInitials(userName);

  return (
    <AvatarRoot className={avatarRoot}>
      {src && <AvatarImage className={avatarImage} src={src} alt={userName} />}
      <AvatarFallback className={avatarFallback} delayMs={600}>
        {initials}
      </AvatarFallback>
    </AvatarRoot>
  );
}
